// Angular Modules

import { environment } from "src/environments/environment";

export class Constants {
  public static lang: any;
  constructor() {
  }

  public static TOKEN = `authorizationserver/oauth/token`;
  public static RESET_PASSWORD = `occ/v2/bhp/cdc/resetPassword`;
  public static FORGET_PASSWORD = `occ/v2/bhp/cdc/forgottenPassword`;
  public static CHECK_USER_CREDENTIALS = `occ/v2/bhp/cdc/login`;
  public static VALIDATE_CODE = `occ/v2/bhp/cdc/validateCode`;
  public static CHECK_INVENTORY_USER_CREDENTIALS="occ/v2/bhp/inventory/inventoryLogin";
  public static INVENTORY_UPDATE_PASSWORD="occ/v2/bhp/inventory/inventoryUpdatePassword";
  public static RESEND_OTP=`occ/v2/bhp/cdc/resendCode`;
  public static ONLYTOKEN = 'authorizationserver/oauth/token';

  public static getgroupuser(userid: any, usergroup: any, lang?: any, currentPage?: any, pageSize?: any, sort?: any,
                             searchInput?: any, quoteStatus?: any): any {
    const URLS = Object({});
    URLS.GROUP_COMPANIES = `occ/v2/bhp/users/${userid}/groupCompanies?fields=DEFAULT`;
    URLS.CONTACTS = `occ/v2/bhp/users/${userid}/orgUnits/${usergroup}/availableOrgCustomers?currentPage=0&fields=DEFAULT&pageSize=300&sort=name`;
    URLS.SAVE_GROUP_COMPANIES_DATA = `occ/v2/bhp/users/${userid}/groupCompanies/${usergroup}?fields=DEFAULT`;
    URLS.TOKEN = `authorizationserver/oauth/token`;
    URLS.MASTERDATA = `occ/v2/bhp/masterData?fields=DEFAULT`;
    URLS.ADDCONTACTS = `occ/v2/bhp/users/${userid}/orgUnit?fields=DEFAULT`;
    URLS.UPDATECONTACTS = `occ/v2/bhp/users/${userid}/orgUnit/`;
    URLS.BHPTEAM = `occ/v2/bhp/users/${userid}/bhpTeamMembers?fields=DEFAULT&orgUnitId=${usergroup}`;

    // URLS.USERLOGIN = `occ/v2/bhp/orgUsers/current?`;
    // URLS.USERLOGIN = `occ/v2/powertools-spa/orgUsers/current?`;
    // ${pageSize} removed for demo and kept 20 as static value for page size
    // URLS.GET_BROWSE_BY_PRODUCTS = `occ/v2/bhp/products/search?browse=byProduct&currentPage=${currentPage}&fields=FULL&orgUnit=${usergroup}&pageSize=30&lang=${lang}&sort=name-asc`;
    // URLS.GET_BROWSE_BY_PRODUCTS_WITH_SEARCH = `occ/v2/bhp/products/search?browse=byProduct&currentPage=${currentPage}&fields=FULL&orgUnit=${usergroup}&pageSize=30&lang=${lang}&sort=name-asc&query=${searchInput}`;
    // URLS.GET_BROWSE_BY_PORT = `occ/v2/bhp/products/search?browse=byPort&currentPage=${currentPage}&fields=FULL&orgUnit=${usergroup}&pageSize=30&lang=${lang}&sort=name-asc`;
    // URLS.GET_BROWSE_BY_PORT_WITH_SEARCH = `occ/v2/bhp/products/search?browse=byPort&currentPage=${currentPage}&fields=FULL&orgUnit=${usergroup}&pageSize=30&lang=${lang}&sort=name-asc&query=${searchInput}`;
    // URLS.GET_BROWSE_BY_ALL = `occ/v2/bhp/products/search?currentPage=${currentPage}&fields=FULL&orgUnit=${usergroup}&pageSize=30&lang=${lang}&sort=name-asc`;
    // URLS.GET_BROWSE_BY_ALL_WITH_SEARCH = `occ/v2/bhp/products/search?currentPage=${currentPage}&fields=FULL&orgUnit=${usergroup}&pageSize=30&lang=${lang}&sort=name-asc&query=${searchInput}`;
    URLS.GET_BROWSE_BY_PRODUCTS = `occ/v2/bhp/products/search?browse=byProduct&currentPage=${currentPage}&fields=FULL&orgUnit=${usergroup}&pageSize=30&sort=name-asc`;
    URLS.GET_BROWSE_BY_PRODUCTS_WITH_SEARCH = `occ/v2/bhp/products/search?browse=byProduct&currentPage=${currentPage}&fields=FULL&orgUnit=${usergroup}&pageSize=30&sort=name-asc&query=${searchInput}`;
    URLS.GET_BROWSE_BY_PORT = `occ/v2/bhp/products/search?browse=byPort&currentPage=${currentPage}&fields=FULL&orgUnit=${usergroup}&pageSize=30&sort=name-asc`;
    URLS.GET_BROWSE_BY_PORT_WITH_SEARCH = `occ/v2/bhp/products/search?browse=byPort&currentPage=${currentPage}&fields=FULL&orgUnit=${usergroup}&pageSize=30&sort=name-asc&query=${searchInput}`;
    URLS.GET_BROWSE_BY_ALL = `occ/v2/bhp/products/search?currentPage=${currentPage}&fields=FULL&orgUnit=${usergroup}&pageSize=30&sort=name-asc`;
    URLS.GET_BROWSE_BY_ALL_WITH_SEARCH = `occ/v2/bhp/products/search?currentPage=${currentPage}&fields=FULL&orgUnit=${usergroup}&pageSize=30&sort=name-asc&query=${searchInput}`;
    URLS.CREATEQUOTE = `occ/v2/bhp/users/${userid}/quotes/submitBid`;
    URLS.GET_CONTRACTS_LIST = `occ/v2/bhp/users/${userid}/ctcontract?fields=FULL`;
    return URLS;
  }
  public static createBid(userid: string, usergroup?: any): any {
    const URLS = Object({});
    URLS.CREATEQUOTE = `occ/v2/bhp/users/${userid}/quotes/submitBid?orgUnitId=${usergroup}`;

    return URLS;
  }

  public static getBidData(userid: string, usergroup: any, quoteStatus?: string, lang?: string, queryParam?: string): any {
    const URLS = Object({});
    URLS.GET_BID_LIST = `occ/v2/bhp/users/${userid}/quotesList?currentPage=0&fields=DEFAULT&pageSize=20&quoteStatus=${quoteStatus}&orgUnitId=${usergroup}${queryParam}`;
    URLS.GET_BID_DETAILS = `occ/v2/bhp/users/${userid}/quotes/${quoteStatus}?fields=FULL&orgUnitId=${usergroup}`;

    return URLS;
  }

  public static getContractFilter( userid:any,usergroup: any ,query:any): any {
    const URLS = Object({});
     URLS.GET_CONTRACTS_LIST = `occ/v2/bhp/users/${userid}/ctcontract?fields=FULL&orgUnitId=${usergroup}${query}`;
    return URLS;
  }
public static getFilterContract(userid:any, usergroup: any, query:any):any{
      const URLS = Object({});
     URLS.GET_FILTERCONTRACT = `occ/v2/bhp/users/${userid}/ctcontract/get-contractfilters?fields=DEFAULT&orgUnitId=${usergroup}${query}`;
    return URLS;

}
  public static profileData(userid: any, usergroup?: any, lang?: any): any{
    const URLS = Object({});
    URLS.GROUP_COMPANIES = `occ/v2/bhp/users/${userid}/groupCompanies?fields=DEFAULT&orgUnitId=${usergroup}`;
    URLS.CONTACTS = `occ/v2/bhp/users/${userid}/orgUnits/${usergroup}/availableOrgCustomers?currentPage=0&fields=DEFAULT&pageSize=300&sort=name`;
    URLS.SAVE_GROUP_COMPANIES_DATA = `occ/v2/bhp/users/${userid}/groupCompanies/${usergroup}?fields=DEFAULT`;
    URLS.ADDCONTACTS = `occ/v2/bhp/users/${userid}/orgUnit?fields=DEFAULT`;
    URLS.UPDATECONTACTS = `occ/v2/bhp/users/${userid}/orgUnit/`;
    URLS.MASTERDATA = `occ/v2/bhp/masterData?fields=DEFAULT`;
    URLS.ADDRESS_BOOK = `occ/v2/bhp/users/${userid}/addressBook?fields=DEFAULT&orgUnitId=${usergroup}`;
    URLS.BHPTEAM = `occ/v2/bhp/users/${userid}/bhpTeamMembers?fields=DEFAULT&orgUnitId=${usergroup}`;
    URLS.CURRENTUSERDATA = `occ/v2/bhp/orgUsers/current?`;
    URLS.NOTIFICATIONCOUNT = `occ/v2/bhp/users/${userid}/quotes/notificationCount?fields=DEFAULT&orgUnitId=${usergroup}`;
    URLS.BHPUNITLIST = `occ/v2/bhp/users/${userid}/b2bUnitList`;
    return URLS;
  }

  public static firstTimePassword(token , newpassword): any{
    const URLS = Object({});
    URLS.RESET_PASSWORD = `occ/v2/bhp/cdc/resetPassword?accessToken=${token}&newPassword=${newpassword}`;
    return URLS;
  }

  public static forgotPassword(username,preference): any{
    const URLS = Object({});
    URLS.FORGET_PASSWORD = `occ/v2/bhp/cdc/forgottenPassword?userId=${username}&preference=${preference}`;
    return URLS;
  }

  public static loginUser(username: any, password: any): any {
    const URLS = Object({});
    URLS.CHECK_USER_CREDENTIALS = `occ/v2/bhp/cdc/login?password=${password}&userId=${username}`;
    return URLS;
  }
  public static inventoryloginUser(username: any, password: any): any {
    const URLS = Object({});
    URLS.CHECK_INVENTORY_USER_CREDENTIALS = `occ/v2/inventorymgt/inventory/inventorylogin?password=${password}&userId=${username}`;
    return URLS;
  }
  public static inventoryUpdatePassword(username: any,password: any,newpassword: any): any{
    const URLS = Object({});
    URLS.INVENTORY_UPDATE_PASSWORD = `occ/v2/bhp/inventory/inventoryUpdatePassword?userId=${username}&newPassword=${password}&newPasswordConfirm=${newpassword}`;
    return URLS;
  }
  public static validateCode(code: any, uid: any , token: any): any {
    const URLS = Object({});
    URLS.VALIDATE_CODE = `occ/v2/bhp/cdc/validateCode?code=${code}&UID=${uid}&vToken=${token}`;
    return URLS;
  }

  public static changePasswordToken(username): any {
    const URLS = Object({});
    URLS.CHANGE_PASSWORD_TOKEN = `occ/v2/bhp/cdc/passwordResetToken?userId=${username}`;
    return URLS;
  }

  public static resendOTP( uid: any , method: any): any {
    const URLS = Object({});
    URLS.RESEND_OTP = `occ/v2/bhp/cdc/resendCode`;
    return URLS;
  }


  //Inventory Management URLS
  public static inventoryData(batchId: any,quotSort?: any):any {
    const URLS = Object({});
    // URLS.INVENTORY_MANAGEMENT = `bhp/inventory`;
    URLS.INVENTORY_DETAILS = `occ/v2/inventorymgt/inventory/list?batchId=${batchId}&fetchQuotes=true&quotesSort=${quotSort}&lang=en&curr=RMB`;
    return URLS;
  }

  public static inventoryManagement(currentPage?: any, sortData?:any, searchValue?:any,query?:any):any {
    const URLS = Object({});
    URLS.INVENTORY_MANAGEMENT = `occ/v2/inventorymgt/inventory/list?currentPage=${currentPage}&fetchQuotes=false&pageSize=300&sortBy=${sortData}&lang=en&curr=RMB`;
    URLS.INVENTORY_FILTER_RESULT = `occ/v2/inventorymgt/inventory/list?currentPage=${currentPage}&fetchQuotes=false&pageSize=300&query=${query}&sortBy=${sortData}&lang=en&curr=RMB`
    URLS.INVENTORY_MANAGEMENT_SEARCH = `occ/v2/inventorymgt/inventory/list?currentPage=${currentPage}&fetchQuotes=false&pageSize=300&productIDSearch=${searchValue}&sortBy=${sortData}&lang=en&curr=RMB`
    return URLS;
  }

  public static inventoryManagementSearch(currentPage?:any, productName?:any): any{
    const URLS = Object({});
    URLS.INVENTORY_MANAGEMENT_SEARCH = `occ/v2/inventorymgt/inventory/list?currentPage=${currentPage}&fetchQuotes=false&pageSize=300&productNameSearch=${productName}&lang=en&curr=RMB`;
    return URLS;
  }

  public static inventoryPublishUnpublishBatch(productCode?: any, toogle?: any, price?: any): any {
    const URLS = Object({});
    URLS.INVENTORY_UNPUBLISH_BATCH = `occ/v2/inventorymgt/inventory/updateBatch/${productCode}/{price}/${toogle}`
    URLS.INVENTORY_PUBLISH_BATCH = `occ/v2/inventorymgt/inventory/updateBatch/${productCode}/${price}/${toogle}`
    return URLS;
  }

  public static inventoryRecordPickup(batchId?: any, contractNumber?:any): any {
    const URLS = Object({});
    // quoteCode = "2493";
    // entryNumber = "0";
    URLS.INVENTORY_PICKUP = `occ/v2/inventorymgt/inventory/${batchId}/${contractNumber}`;
    URLS.INVENTORY_PICKUP_SAVE = `occ/v2/inventorymgt/inventory/submitNominationItemPickUpRecord`;
    return URLS; 
  }

  public static inventoryUpdatePrice(productCode: any, price: any): any {
    const URLS = Object({});
    URLS.INVENTORY_UPDATE_PRICE = `occ/v2/inventorymgt/inventory/updatePrice/${productCode}/${price}`
    return URLS;
  }

  public static getPrivacyPolicy(lang?: any): any {
    const URLS = Object({});
    URLS.PRIVAY_POLICY = `occ/v2/bhp/privacyPolicyAndTermsofUse?fields=DEFAULT`;
    return URLS;
  }

  public static getFaqDownloadLink(data: any) : any{
    const URLS = Object({});
    // URLS.DOWNLOAD_FAQ = `occ/v2/bhp/faqDownloadLinks?fields=DEFAULT&identfier=${data}`;
    URLS.DOWNLOAD_FAQ = `occ/v2/bhp/faqDownloadLinks?fields=DEFAULT`
    return URLS;
  }
  
  public static getShipmentList(userid: any, tab:any ,usergroup?: any, currentPage?: any, query?):any{
    const URLS = Object({});
    URLS.SHIPMENT_LIST=`occ/v2/bhp/users/${userid}/shipment?currentPage=${currentPage}&fields=DEFAULT&orgUnitId=${usergroup}&pageSize=20${query}&shipmentTab=${tab}`;
    return URLS;
  }
  public static getShipmentDetailsData(userId: any, userGroup: any, shipmentId: any, dischargePoint: any, loadPort: any){
    const URLS = Object({});
    URLS.SHIPMENT_DETAILS = `occ/v2/bhp/users/${userId}/shipment/${shipmentId}?dischargePoint=${dischargePoint}&fields=DEFAULT&loadPort=${loadPort}&orgUnitId=${userGroup}&shipmentId=${shipmentId}`
    //URLS.SHIPMENT_DETAILS = `occ/v2/bhp/users/ansell.augustine%40bhp.com/shipment//{shipmentId}?dischargePoint=CN-CAOFEID&fields=DEFAULT&loadPort=Port%20Hedland&orgUnitId=301118351&shipmentId=1424130`;
    return URLS;
  }
  public static getSdocsString(userId: any,documentID: any,setID: any,nominationKey:any,nominationKeyItem:any){
    const URLS = Object({});
    if(setID)
    {
    URLS.BASE64=`occ/v2/bhp/users/${userId}/shipment/getSinglePdf?documentID=${documentID}&fields=DEFAULT&setID=${setID}`
    } 
    else{
    URLS.BASE64=`occ/v2/bhp/users/${userId}/shipment/getSinglePdf?documentID=${documentID}&fields=DEFAULT&nominationNumberKey=${nominationKey}&nominationItemNumber=${nominationKeyItem}`
    }
    return URLS;
  }
  public static getEDRDetails(userId: any,ExternalQuoteID: any){
    const URLS = Object({});
    URLS.SCRM_EDR=`occ/v2/bhp/users/${userId}/quotes/${ExternalQuoteID}/TCPdf`
    return URLS;
  }
  public static getPDFDetails(userId: any,quoteID: any){
    const URLS = Object({});
    URLS.SCRM_PDF=`occ/v2/bhp/users/${userId}/quotes/TCPdf?quoteCode=${quoteID}`
    return URLS;
  }
  public static getBidAttachment(userId: any,c4cUUID:any){
    const URLS = Object({});
    URLS.BID_ATTACHMENT=`occ/v2/bhp/users/${userId}/quotes/${c4cUUID}/bidattachements`
    return URLS;
  }
  //open negotiations urls
  public static getTenders(userId: any,usergroup: any,currentPage:any,tenderStatus?:string,query?){
    const URLS = Object({});
    URLS.TENDERS_DATA=`occ/v2/bhp/users/${userId}/tenders/tenderLists?currentPage=${currentPage}&fields=DEFAULT&orgUnitId=${usergroup}&pageSize=20&tenderStatus=${tenderStatus}${query}`
    return URLS;
  }
  public static submitTender(userId: any,usergroup: any){
    const URLS = Object({});
    URLS.SAVE_TENDER=`occ/v2/bhp/users/${userId}/tenders/placeBid?orgUnitId=${usergroup}`
    return URLS;
  }
public static consentUpdateDetails(userId:any, lastConsentModified_Terms: any, currentDocDate_Privacy: any, currentDocDate_Terms: any,lastConsentModified_Privacy:any ){
    const URLS = Object({});
    URLS.CONSENT_UPDATE_DETAILS=`occ/v2/bhp/users/${userId}/consentUpdateDetails?LastConsentModified_Terms=${lastConsentModified_Terms}&currentDocDate_Privacy=${currentDocDate_Privacy}&currentDocDate_Terms=${currentDocDate_Terms}&lastConsentModified_Privacy=${lastConsentModified_Privacy}`
    return URLS;
  }
  public static updateUserConsents(userId:any, uId:any){
    const URLS = Object({});
    URLS.UPDATE_USER_CONSENTS=`occ/v2/bhp/users/${userId}/updateUserConsentAcceptance?uid=${uId}`
    return URLS;
  }
  public static getMessageFromBundle(tab:any, lang:any ):any{
    const URLS = Object({});
    URLS.MESSAGE=`occ/v2/bhp/bhpMessageBundle?code=${tab}&lang=${lang}`;
    return URLS;
  }
  public static getvesselNomination(userId:any, usergroup:any, shipmentId: any, vesselStatus: any ):any{
    const URLS = Object({});
    URLS.VESSELDATA=`occ/v2/bhp/users/${userId}/shipment/${shipmentId}/vesseldetail?reviewStatus=${vesselStatus}&fields=DEFAULT&orgUnitId=${usergroup}`;
    return URLS;
  }
  public static vesselNomination(userId: any,usergroup: any, shipmentId: any , vesselStatus: any, vesselRemarks: any){
    const URLS = Object({});
    URLS.VESSEL_NOMINATION=`occ/v2/bhp/users/${userId}/shipment/${shipmentId}/reviewvessel?reviewStatus=${vesselStatus}&fields=DEFAULT&orgUnitId=${usergroup}&reviewReason=${vesselRemarks}`
    return URLS;
  }
  public static GetSMSCountries(){ 
    const URLS=`occ/v2/bhp/smsDisabledCountries?fields=DEFAULT`
    return URLS;
  }
  public static getASMAccess(){
    const GetAsmAccessURL=`occ/v2/bhp/checkAsmAccess`
    return GetAsmAccessURL;
  }
  public static exportReport(type?: string, baseProductCode?:any, batchId?: any, usergroup?: any,shipmentTab?:any) {
    const URLS = Object({});
    if(baseProductCode){
      URLS.SEABORNE_REPORT = `occ/v2/bhp/exportreport/download?fields=DEFAULT&batchId=${baseProductCode}&reportType=${type}&b2bUnitId=${usergroup}`
    }else 
      if(batchId){
      URLS.SEABORNE_REPORT = `occ/v2/bhp/exportreport/download?fields=DEFAULT&reportType=${type}&b2bUnitId=${usergroup}&batchId=${batchId}`
    }
    else if(shipmentTab){
      URLS.SEABORNE_REPORT = `occ/v2/bhp/exportreport/download?fields=DEFAULT&reportType=${type}&b2bUnitId=${usergroup}&statusTab=${shipmentTab}`
    }
    else{
            URLS.SEABORNE_REPORT = `occ/v2/bhp/exportreport/download?fields=DEFAULT&reportType=${type}&b2bUnitId=${usergroup}`
    }
    return URLS;
  }
  public static getShipmentData(data?,queryParam?,searchtext?,usergroup?,userId?,display?){
    const currentPage = data.currentPage;
    const URLS = Object({});
    if(display=='bondedwarehouseShipmentList'){
      URLS.SHIPMENT_LIST = `occ/v2/bhp/users/${userId}/portside-partner-management/shipment-list?${queryParam}&b2bUnitId=${usergroup}&currentPage=${currentPage}&fields=FULL&channel=STOREFRONT&salesArea=BW`
    }else{
      URLS.SHIPMENT_LIST = `occ/v2/bhp/users/${userId}/portside-partner-management/shipment-list?${queryParam}&b2bUnitId=${usergroup}&currentPage=${currentPage}&fields=FULL&channel=STOREFRONT`
    }
    return URLS;
  }
  public static getShipmenFilters(userid:string,queryParam:string){
    const URLS = Object({});
    if(queryParam){
      URLS.filters = `occ/v2/bhp/users/${userid}/portside-partner-management/get-filters?${queryParam}`
    }else{
      URLS.filters = `occ/v2/bhp/users/${userid}/portside-partner-management/get-filters`
    } 
    return URLS;
  }
  public static getShipmentInspectionFilters(userid:string,queryParam:string){
    const URLS = Object({});
      URLS.filters = `occ/v2/bhp/users/${userid}/portside-partner-management/get-filters?pageId=INSP${queryParam}`
    return URLS;
  }
  
  public static getShipmentdetail(nominationKey?:any, nominationKeyItem?:any,userId?:any,nomination?:any){
    const URLS = Object({});
    URLS.SHIPMENT_DETAIL = `occ/v2/bhp/users/${userId}/portside-partner-management/shipment-details/${nomination}?nominationKey=${nominationKey}&nominationKeyItem=${nominationKeyItem}&fields=FULL&channel=STOREFRONT`
    return URLS;
  }
  public static saveShipmentdetail(userid){
    const URLS = Object({});
    URLS.SAVESHIPMENT_DETAIL = `occ/v2/bhp/users/${userid}/portside-partner-management/shipment-details/update?fields=FULL&channel=STOREFRONT`
    return URLS;
  }
   public static saveConsignmentPlaceOrder(userid,usergroup){
    const URLS = Object({});
    URLS.SAVE_CONSIGNMENT_PLACE_ORDER = `/occ/v2/bhp/users/${userid}/quotes/submitBid?commodityType=PO&orgUnitId=${usergroup} `
    return URLS;
  }
  
  public static saveShipmentInspectionUpdate(userid, isValidateSave: boolean = false){
    const URLS = Object({});
    URLS.SAVESHIPMENT_INSP = `occ/v2/bhp/users/${userid}/portside-partner-management/shipment-details/update?fields=FULL&channel=STOREFRONT&partnerType=INSP&isValidateSave=${isValidateSave}`
    return URLS;
  }
  public static uploaddoc(nominationNo,userId,data){
    const URLS = Object({});
    URLS.UPLOAD_DOCUMENT = `occ/v2/bhp/users/${userId}/portside-partner-management/${nominationNo}/document?nominationKey=${data.nominationKey}&nominationKeyItem=${data.nominationKeyItem}&fields=FULL`
    return URLS;
  }
  public static uploadInspdocument(nominationNo,userId,data){
    const URLS = Object({});
    URLS.UPLOAD_INSP_DOCUMENT = `occ/v2/bhp/users/${userId}/portside-partner-management/${nominationNo}/document?nominationKey=${data.nominationKey}&nominationKeyItem=${data.nominationKeyItem}&fields=FULL&partnerType=INSP`
    return URLS;
  }
  public static removedoc(nominationNo,userId,data){
    const URLS = Object({});
    URLS.REMOVE_DOC = `occ/v2/bhp/users/${userId}/portside-partner-management/${nominationNo}/document?nominationKey=${data.nominationKey}&nominationKeyItem=${data.nominationKeyItem}&documentId=${data.documentId}`
    return URLS;
  }
  public static removeBatchScreeningdocument(code,userId,data){
    const URLS = Object({});
    URLS.REMOVE_BATCH_DOC = `occ/v2/bhp/users/${userId}/screening-operation/${code}/document?documentId=${data.documentId}`
    return URLS;
  }
  public static removeBatchDeliverydocument(code,userId,data){
    const URLS = Object({});
    URLS.REMOVE_BATCH_DOC = `occ/v2/bhp/users/${userId}/deliverytracking/remove-document?batchId=${code}&documentId=${data.documentId}`
    return URLS;
  }
  
  public static removeInspdoc(nominationNo,userId,data){
    const URLS = Object({});
    URLS.REMOVE_INSP_DOC = `occ/v2/bhp/users/${userId}/portside-partner-management/${nominationNo}/document?nominationKey=${data.nominationKey}&nominationKeyItem=${data.nominationKeyItem}&documentId=${data.documentId}&partnerType=INSP`
    return URLS;
  }
  public static getDeliverytrackingDetails(baseProductCode?:any,batchId?:any,userId?:any){
    const URLS = Object({});
    URLS.DELIVERYTRACKING_DETAILS = `occ/v2/bhp/users/${userId}/portside-partner-management/batch-details?batchId=${baseProductCode}_${batchId}&fields=FULL`
    return URLS;
  }
  public static saveBatchCompleted(batchId,userId,status){
    const URLS = Object({});
    URLS.BATCHCOMPLETED=`occ/v2/bhp/users/${userId}/deliverytracking/${batchId}/batchstatus?batchStatus=${status}`
    return URLS;
  }
  public static getbatchesScreeningList(data?,queryParam?,searchtext?,userId?,usergroup?){
    const currentPage = data.currentPage;
    const status = data.status;
    const URLS = Object({});
    // if(searchtext){
    //   URLS.BATCHESSCREENING_LIST = `occ/v2/bhp/users/${userId}/screening-operation/batchScreening-list?${queryParam}&b2bUnitId=${usergroup}&currentPage=${currentPage}&channel=BACKOFFICE&searchText=${searchtext}&fields=FULL`
    // }else{
      URLS.BATCHESSCREENING_LIST = `occ/v2/bhp/users/${userId}/screening-operation/batchScreening-list?${queryParam}&b2bUnitId=${usergroup}&currentPage=${currentPage}&channel=BACKOFFICE&fields=FULL`
    // }
    return URLS;
  }
  public static getDeliverytrackingList(data?,queryParam?,searchtext?,userId?,usergroup?){
    const currentPage = data.currentPage;
    const status = data.status;
    const URLS = Object({});
    if(searchtext){
      URLS.DELIVERYTRAKING_LIST = `occ/v2/bhp/users/${userId}/portside-partner-management/batch-list?${queryParam}&b2bUnitId=${usergroup}&currentPage=${currentPage}&channel=BACKOFFICE&searchText=${searchtext}&fields=FULL`
    }else{
      URLS.DELIVERYTRAKING_LIST = `occ/v2/bhp/users/${userId}/portside-partner-management/batch-list?${queryParam}&b2bUnitId=${usergroup}&currentPage=${currentPage}&channel=BACKOFFICE&fields=FULL`
    }
    return URLS;
  }
  public static saveRecordPickUp(userId, isvalidateSave){
    const URLS = Object({});
    if(isvalidateSave){
      URLS.RECORD_PICK_UP = `occ/v2/bhp/users/${userId}/deliverytracking/UpdateDeliveryRecords?isValidateSave=${isvalidateSave}`
    }else{
      URLS.RECORD_PICK_UP = `occ/v2/bhp/users/${userId}/deliverytracking/UpdateDeliveryRecords`
    }
    return URLS;
  }
   public static validateRecordPickUp(userId, nomination, nominationKey, nominationKeyItem,batchId, type = 'FINALINVOICE_UC1', sysSubType: any,usergroup?:any){
    const URLS = Object({});
       if (batchId) {
      URLS.VALIDATE_RECORDS = `occ/v2/bhp/users/${userId}/azure/validate-records?batchId=${batchId}&type=${type}&b2bUnitId=${usergroup}`;

    } else {
      URLS.VALIDATE_RECORDS = `occ/v2/bhp/users/${userId}/azure/validate-records?nomination=${nomination}&nominationKey=${nominationKey}&nominationKeyItem=${nominationKeyItem}&type=${type}&b2bUnitId=${usergroup}`;
      if (sysSubType !== undefined && sysSubType !== null) {
        URLS.VALIDATE_RECORDS += `&sysSubType=${sysSubType}`;
      }
    }
    return URLS;
  }
 public static getInvoiceDetails(batchId: any, nomination: any, nominationKey: any, nominationKeyItem: any, useCaseType: any, systemSubType: any): any {
    const URLS = Object({});
   if (batchId) {
      URLS.INVOICE_DETAILS = `occ/v2/bhp/invoice-details?batchId=${batchId}&useCaseType=${useCaseType}`;
            if (typeof systemSubType === 'string') {
        URLS.INVOICE_DETAILS += `&systemSubType=${systemSubType}`;
      }

    } else {
      URLS.INVOICE_DETAILS = `occ/v2/bhp/invoice-details?nomination=${nomination}&nominationKey=${nominationKey}&nominationKeyItem=${nominationKeyItem}&useCaseType=${useCaseType}`;
      if (typeof systemSubType === 'string') {
        URLS.INVOICE_DETAILS += `&systemSubType=${systemSubType}`;
      }
    }
        return URLS;
  }

  public static getPortInvoices(nomination: any, nominationKey: any, nominationKeyItem: any, batchId?: any, useCaseType?: any): any {
    const URLS = Object({});
     if (batchId) {
      URLS.PORT_INVOICES = `occ/v2/bhp/invoices?batchId=${batchId}&useCaseType=${useCaseType}`;
    }
    else {
      URLS.PORT_INVOICES = `occ/v2/bhp/port-invoices?nomination=${nomination}&nominationKey=${nominationKey}&nominationKeyItem=${nominationKeyItem}`;
    }
    return URLS;
  }

  public static validationResponse(baseSiteId: string, userId: string,batchId?:any,useCaseType?:any): any {
    const URLS = Object({});
    URLS.VALIDATION_RESPONSE = `occ/v2/${baseSiteId}/azure/update-response?isSesTriggered=true&userId=${userId}`;
    if (batchId) {
      URLS.VALIDATION_RESPONSE += `&batchId=${batchId}`;
    }
    if (useCaseType) {
      URLS.VALIDATION_RESPONSE += `&useCaseType=${useCaseType}`;
    }
    return URLS;
  }

  public static getMasterData(pageID=''){
    const URLS = Object({});
    URLS.MASTERDATA = `occ/v2/bhp/masterData?fields=DEFAULT&pageId=${pageID}`;
    return URLS;
  }

  public static getShipmentInspectionData(data?,queryParam?,usergroup?,userId?){
    const currentPage = data.currentPage;
    const URLS = Object({});
    // if(searchtext){
    //    URLS.SHIPMENT_INSP_LIST = `occ/v2/bhp/users/${userId}/portside-partner-management/shipment-list?${queryParam}&b2bUnitId=${usergroup}&currentPage=${currentPage}&fields=FULL&channel=STOREFRONT&searchText=${searchtext}&partnerType=INSP`
    // }else{
       URLS.SHIPMENT_INSP_LIST = `occ/v2/bhp/users/${userId}/portside-partner-management/shipment-list?${queryParam}&b2bUnitId=${usergroup}&currentPage=${currentPage}&fields=FULL&channel=STOREFRONT&partnerType=INSP`
    //}
    return URLS;
  }
  public static getShipRailList(userId?, data?, usergroup?,queryParams?) {
    const currentPage = data.currentPage;
    const tab = data.shipmentTab
    const URLS = Object({});
    URLS.RAILLIST = `occ/v2/bhp/users/${userId}/shipsdocsrail/shipsdocsraillist?currentPage=${currentPage}&fields=DEFAULT&orgUnitId=${usergroup}&pageSize=20&shipmentStatus=${tab}${queryParams}`;
    return URLS;
  }
  public static getConsignmentList(userId?,usergroup?,data?,queryParam?) {
    const tab = data.groupBy
    const URLS = Object({});
    URLS.PM_CONSIGN_LIST = `occ/v2/bhp/users/${userId}/consignment/getCustomerConsignments?externalPartnerId=${usergroup}&fields=DEFAULT&groupBy=${tab}${queryParam}`;
    return URLS;
  }
   public static getLocationTabfilters(userId?,tradePartnerId?){
    const URLS = Object({});
    URLS.filters = `occ/v2/bhp/users/${userId}/consignadminlocation/get-consignfilters?fields=DEFAULT&externalTradePartnerId=${tradePartnerId}`
    return URLS;
  }
  public static getShipConsignmentList(userId,usergroup?, data?,  queryParams?) {
    const tab = data.shipmentTab
    const URLS = Object({});
    URLS.CONSLIST = `occ/v2/bhp/users/${userId}/shipsdocsConsignment?fields=DEFAULT&isListing=true&orgUnitId=${usergroup}&shipmentTab=${tab}${queryParams}`;
    return URLS;
  }

  public static getBatchesScreeningDetails(baseProductCode?:any,batchId?:any,userId?:any){
    const URLS = Object({});
    URLS.BATCHESSREENING_DETAILS = `occ/v2/bhp/users/${userId}/screening-operation/batchScreening-details?batchId=${baseProductCode}_${batchId}&fields=FULL`
    return URLS;
  }
  public static getShipConsignDetails(userId?:any,usergroup?:any,consignNumber?:any,tab?:any){
    const URLS = Object({});
    URLS.SHIPCONSIGN_DETAILS = `occ/v2/bhp/users/${userId}/shipsdocsConsignment?isListing=false&orgUnitId=${usergroup}&searchText=${consignNumber}&shipmentTab=${tab}`
    return URLS;
  }

  public static saveBatchScreeningStatus(batchId,userId,status){
    const URLS = Object({});
    URLS.BATCHCOMPLETED=`occ/v2/bhp/users/${userId}/screening-operation/${batchId}/Screening-Status?screeningStatus=${status}`
    return URLS;
  }
  public static updateScreeningEntry(userId,productCode,batchId){
    const URLS = Object({});
    URLS.BATCHCOMPLETED=`occ/v2/bhp/users/${userId}/screening-operation/batchScreening-saveEntries?batchId=${productCode}_${batchId}&fields=DEFAULT`
    return URLS;
  }
  public static uploadScreeningDocs(userId,batchId){
    const URLS = Object({});
    URLS.upload=`occ/v2/bhp/users/${userId}/screening-operation/${batchId}/document`
    return URLS;
  }

  
  public static uploadDeliveryDocs(userId,batchId){
    const URLS = Object({});
    URLS.upload=`occ/v2/bhp/users/${userId}/deliverytracking/upload-documents?batchId=${batchId}`
	return URLS;
  }


  public static getShipRailDetails(userId,userGroup,requestParams?,nominationNo?,query?){
    const URLS = Object({});
    URLS.RAILDETAILS = `occ/v2/bhp/users/${userId}/shipsdocsrail?currentPage=${requestParams.currentPage}&fields=DEFAULT&orgUnitId=${userGroup}&pageSize=${requestParams.pageSize}&nominationNumber=${nominationNo}${query}`;  
    return URLS;
  }
   public static getConsignmentPlaceOrderDetails(userId,materialId,seqNumber,shipToId){
    const URLS = Object({});
    URLS.PLACE_ORDER_DETAILS = `occ/v2/bhp/users/${userId}/consignadminplaceorder/placeOrderDetails?fields=DEFAULT&materialId=${materialId}&seqNumber=${seqNumber}&shipToId=${shipToId}`;  
    return URLS;
  }
  public static getFiltersShipsDocs(userId,pageID){
    const URLS = Object({});
    URLS.FILTERS = `occ/v2/bhp/users/${userId}/portside-partner-management/get-filters?fields=DEFAULT&pageId=${pageID}`;  
    return URLS;
  }
  public static getTokenFromCDC(identifier,identifierType){
    const URLS = Object({});
   // URLS.CDC_TOKEN=`https://accounts.${environment.CDCDATACentre}/accounts.identifiers.createToken?identifier=${identifier}&identifierType=${identifierType}&apikey=${environment.cdc.apiKey}`
    return URLS;
}
public static logincdc(email,password){
    const URLS = Object({});
    //URLS.CDC_TOKEN=`https://accounts.${environment.CDCDATACentre}/accounts.login?loginID=${email}&password=${password}&apikey=${environment.cdc.apiKey}`
    return URLS;
}
public static updatebiometrics(enabledornot:boolean,userId:any){
    const URLS = Object({});
    URLS.biometricFlag=`occ/v2/bhp/users/${userId}/biometric/${enabledornot}`
    return URLS;
}

 public static getQualityInspectionList(userid:any,query:any,usergroup?:any){
    const URLS = Object({});
    URLS.GET_QUALITY_INSPECTION_LIST = `occ/v2/bhp/users/${userid}/quality-inspection?fields=FULL&channel=STOREFRONT&b2bUnitId=${usergroup}${query ? `&${query}` : ''}`;
    return URLS;
  }
  public static saveLot(userid:any,code:any){
    const URLS = Object({});
    URLS.SAVE_LOT = `/occ/v2/bhp/users/${userid}/quality-inspection/details/${code}`
    return URLS;
  }
  public static getQualityInspectionDetails(userid:any,code:any){
    const URLS = Object({});
    URLS.QUALITY_INSPECTION_DETAILS = `occ/v2/bhp/users/${userid}/quality-inspection/details/${code}`
    return URLS;
  }
  public static qualityInspectionCompleted(userid:any,code:any){
    const URLS = Object({});
    URLS.QUALITY_INSPECTION_COMPLETED = `occ/v2/bhp/users/${userid}/quality-inspection/status-update/${code}?inspectionStatus=COMPLETED`
    return URLS;
  }
    public static deleteQualityAttachment(userid:any) :any{
    const URLS = Object({});
    URLS.DELETE_ATTACHMENT = `occ/v2/bhp/users/${userid}/quality-inspection/remove-attachment`
    return URLS;
  }
   public static verifyToken():any{
    const url = `occ/v2/bhp/cdc/verify-user-kmli-session`;
    return url;
  }
   public static Logout():any{
    const url = `occ/v2/bhp/cdc/logout`;
    return url;
  }

}




